<template>
  <div>
    <div
      v-if="authors.length === 1"
      class="flex items-center"
    >
      <q-avatar size="44px">
        <AccountAvatar :url="authors[0].image?.url" />
      </q-avatar>
      <div class="q-ml-md flex column">
        <div>{{ authors[0].displayName }}</div>
        <div class="fs-12 text-grey">{{ authors[0].description }}</div>
      </div>
    </div>
    <q-item
      v-else
      class="menu-target flex items-center cursor-pointer"
      clickable
    >
      <q-avatar
        v-for="author in slicedAuthors"
        :key="author.guid"
        size="44px"
        class="multiple-avatar"
      >
        <AccountAvatar
          :url="author.image?.url"
          size="40px"
        />
      </q-avatar>
      <div class="text-primary q-ml-md">
        {{ $t('text.authors', authors.length) }}
      </div>

      <q-menu
        ref="popupRef"
        class="blog-post-actions-popup bg-white border-radius-10 q-pa-md"
      >
        <div class="flex justify-between items-center fs-12 text-grey q-mb-md">
          {{ $t('text.authors', authors.length) }}
          <AppBtn
            size="xs"
            padding="4px"
            @click="$refs.popupRef.hide()"
          >
            <q-icon
              name="img:/close.svg"
              class="text-grey"
              size="12px"
            />
          </AppBtn>
        </div>
        <div class="flex column gap-md">
          <div
            v-for="author in authors"
            :key="author.guid"
            class="flex"
          >
            <q-avatar
              size="40px"
            >
              <AccountAvatar :url="author.image?.url" />
            </q-avatar>
            <div class="q-ml-md flex column justify-center">
              <div>{{ author.displayName }}</div>
              <div class="fs-12 text-grey">
                {{ author.description }}
              </div>
            </div>
          </div>
        </div>
      </q-menu>
    </q-item>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import AccountAvatar from 'components/AccountAvatar.vue';
import AppBtn from 'components/AppBtn.vue';

const props = defineProps({
  authors: {
    type: Array,
    required: true,
  },
});

const popupRef = ref(null);

const slicedAuthors = computed(() => props.authors.slice(0, 4));
</script>

<style lang="scss" scoped>
.multiple-avatar {
  &:not(:first-child) {
    margin-left: -8px;
  }

  :deep(.q-avatar__content) {
    border: 2px solid white;
  }
}

:deep(.q-item) {
  padding: 0;

  .q-focus-helper {
    display: none;
  }
}
</style>
